/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { FormGroup, Label, Input, Row, Col } from 'reactstrap'

import Select  from 'react-select'
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';

import {AppContext} from '../../AppContext';

class DateKeywordValue extends React.Component
{

  constructor(props)
  {
    super();

    let keywordValue = 'date' === props.keywordAndValue.keywordValueType ? props.keywordAndValue.dateValue :
      props.keywordAndValue.timestampValue;

    if (undefined === keywordValue) keywordValue = '';

    this.state =
    {
      suggestedValues: [],
      keywordValue: keywordValue,
      newDateDisabled: ('' === keywordValue ? false : true),
    };

    this.setDateValue = this.setDateValue.bind(this);
    this.selectChangeHandler = this.selectChangeHandler.bind(this);
    this.dateRadioClicked = this.dateRadioClicked.bind(this);
  }
  
  componentDidMount()
  {
    if ('dynamic list' === this.props.keywordAndValue.userInputHandling || 
        'static list' === this.props.keywordAndValue.userInputHandling)
      this.fetchSuggestedValues();
  }

  dateRadioClicked(selection)
  {
    this.setState({newDateDisabled: !this.state.newDateDisabled})
  }

  async fetchSuggestedValues()
  {
    let bodyData = {keywordId: this.props.keywordAndValue.keywordId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSuggestions', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading keyword value suggestions');    
    for (let x = 0; x < result.jsonData.suggestedValues.length; x++)
    {
      if ('date' === this.props.keywordAndValue.keywordValueType)
        result.jsonData.suggestedValues[x].displayValue = window.moment.unix(result.jsonData.suggestedValues[x].keywordValue).utc().format('LL');
      else if ('time' === this.props.keywordAndValue.keywordValueType)
        result.jsonData.suggestedValues[x].displayValue = window.moment.unix(result.jsonData.suggestedValues[x].keywordValue).utc().format('LTS');
      else if ('timestamp' === this.props.keywordAndValue.keywordValueType)
        result.jsonData.suggestedValues[x].displayValue = window.moment.unix(result.jsonData.suggestedValues[x].keywordValue).utc().format('LL LTS');
    }

    this.setState({suggestedValues: result.jsonData.suggestedValues});
  }

  render()
  {
    let dateFormat = false;
    let timeFormat = false;

    switch (this.props.keywordAndValue.keywordValueType)
    {
      case 'date':
        dateFormat = true;
        break;

      case 'timestamp':
        dateFormat = true;
        timeFormat = true;
        break;

      case 'time':
        timeFormat = true;
        break;

      default:
        break;
    }

    if ('dynamic list' === this.props.keywordAndValue.userInputHandling)
      return this.renderInputAndSuggested(dateFormat, timeFormat);

    if ('no suggestions' === this.props.keywordAndValue.userInputHandling)
      return this.renderInput(dateFormat, timeFormat);

    if ('static list' === this.props.keywordAndValue.userInputHandling)
      return this.renderSuggested();

    return (<div><p>This keyword is not setup properly to allow user input or offer suggested values.</p></div>);
  }

  renderInputAndSuggested(dateFormat, timeFormat)
  {
    let displayValue = null;

    if ('date' === this.props.keywordAndValue.keywordValueType)
      displayValue = window.moment.unix(this.state.keywordValue).utc().format('LL');
    else if ('time' === this.props.keywordAndValue.keywordValueType)
      displayValue = window.moment.unix(this.state.keywordValue).utc().format('LTS');
    else if ('timestamp' === this.props.keywordAndValue.keywordValueType)
      displayValue = window.moment.unix(this.state.keywordValue).utc().format('LL LTS');

    let keywordValueObj = undefined;
    var keywordValue = undefined;

    if (!this.state.newDateDisabled)
    {
      if ('' === this.state.keywordValue)
        keywordValue = window.moment.unix();
      else
        keywordValue = window.moment.unix(this.state.keywordValue);
    }
    else
    {
      if ('' !== this.state.keywordValue)
        keywordValueObj = {keywordValue: this.state.keywordValue, displayValue: displayValue}
    }

    let formFeedback = null;

    if (!this.props.validValue)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>You must provide or select an existing value...!!!</Col></Row>
        </div>
      );

  // NOTE: we could also open the picker upward: className='react-datetime-open-upward"
    return(
      <div>
        <FormGroup row check className='form-check-inline'>
          <Col sm="1">
            <Input type="radio" defaultChecked={(this.state.newDateDisabled ? "" : "checked")} name="dateRadio" id="newDateRadio" 
              onClick={this.dateRadioClicked}/>
          </Col>
          <Col><Label check for='newDateRadio'>Input a new date value...</Label></Col>
        </FormGroup>
        <FormGroup row>
          <Col>
          <Datetime
            className="react-datetime-transparent" 
            inputProps=
            {{
              placeholder: 'Input a date value...',
              id: 'keywordValue',
              disabled: this.state.newDateDisabled
            }}
            utc={true}
            timeFormat={timeFormat}
            dateFormat={dateFormat}
            onChange={this.setDateValue}
            value={keywordValue}
          />
          </Col>
        </FormGroup>
        <FormGroup row check className='form-check-inline'>
          <Col sm="1">
            <Input type="radio" defaultChecked={(this.state.newDateDisabled ? "checked" : "")} name="dateRadio" id="existingDateRadio" 
              onClick={this.dateRadioClicked}/>
          </Col>
          <Col><Label check for='existingDateRadio'>...or select an existing date.</Label></Col>
        </FormGroup>
        <Row>
          <Col>
            <Select value={keywordValueObj} options={this.state.suggestedValues} 
              getOptionLabel={option => option.displayValue} getOptionValue={option => option.keywordValue}
              onChange={this.selectChangeHandler} placeholder='Select a date value...' isDisabled={!this.state.newDateDisabled}
            />
          </Col>
        </Row>
        {formFeedback}
      </div>
    );
  }

  renderInput(dateFormat, timeFormat)
  {
    let formFeedback = null;

    if (!this.props.validValue)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>You must provide a valid value...!!!</Col></Row>
        </div>
      );

    let keywordValue = window.moment.unix();
    if ('' !== this.state.keywordValue) keywordValue = this.state.keywordValue;

    return(
      <div>
        <Row>
          <Col>
            <Datetime
              inputProps=
              {{
                placeholder: 'Provide a date value...',
                id: 'keywordValue',
                autoFocus: true 
              }}
              timeFormat={timeFormat} dateFormat={dateFormat} utc={true}
              onChange={this.setDateValue} value={window.moment.unix(keywordValue)}
              open={this.props.openDatePicker} input={false}
            />
          </Col>
        </Row>
        {formFeedback}
      </div>
    );
  }

  renderSuggested()
  {
    let displayValue = null;

    if ('date' === this.props.keywordAndValue.keywordValueType)
      displayValue = window.moment.unix(this.state.keywordValue).utc().format('LL');
    else if ('time' === this.props.keywordAndValue.keywordValueType)
      displayValue = window.moment.unix(this.state.keywordValue).utc().format('LTS');
    else if ('timestamp' === this.props.keywordAndValue.keywordValueType)
      displayValue = window.moment.unix(this.state.keywordValue).utc().format('LL LTS');

    let keywordValue = undefined;
    if ('' !== this.state.keywordValue) keywordValue = {keywordValue: this.state.keywordValue, displayValue: displayValue}

    let formFeedback = null;

    if (!this.props.validValue)
      formFeedback = (
        <div style={{color: 'red'}}>
          <Row><Col>You must select a value...!!!</Col></Row>
        </div>
      );

    return(
      <div>
        <Row>
          <Col>
            <Select id="keywordValue" value={keywordValue} options={this.state.suggestedValues}
              getOptionLabel={option => option.displayValue} getOptionValue={option => option.keywordValue} autoFocus
              onChange={this.selectChangeHandler} onInputKeyDown={this.handleKeyDown} placeholder='Select a date value...'
            />
          </Col>
        </Row>
        {formFeedback}
      </div>
    );
  }

  selectChangeHandler(selectedOption, actionMetaD)
  {
    if (null === selectedOption) return;
    this.setDateValue(selectedOption.keywordValue);
  }

  setDateValue(date)
  {
    if (typeof date !== 'object')
    {
      this.setState({keywordValue: date});
      this.props.setSaveButtonDisabled(false);
      this.props.setKeywordValue(date);
    }
    else
    {
      this.setState({keywordValue: date.unix()});
      this.props.setSaveButtonDisabled(false);
      this.props.setKeywordValue(date.unix());
    }
  }
}

DateKeywordValue.contextType = AppContext;

export default DateKeywordValue
